export default defineNuxtPlugin(async (nuxtApp) => {
  const toReasonMessage = (reason: unknown) => {
    if (reason instanceof Error) return reason.message;
    try {
      return JSON.stringify(reason);
    } catch {
      return String(reason);
    }
  };
  const openFortTimeout = useCookie("openFortTimeout");
  if (openFortTimeout.value === undefined) openFortTimeout.value = "false";
  if (import.meta.client) {
    onNuxtReady(async () => {
      generateAndStoreDeviceId();
      storeReferralId();
    });
  }

  const [merchantsResult, gfalExResult, loginResult] = await Promise.allSettled([
    useAppStateStore().getMerchants(),
    useGFALExStore().getGFALExSnapshot(),
    useAuthController().userLogin(),
  ]);

  if (merchantsResult.status === "rejected") {
    console.error(
      "initPlugin getMerchants error",
      toReasonMessage(merchantsResult.reason),
    );
  }
  if (gfalExResult.status === "rejected") {
    console.error(
      "initPlugin getGFALExSnapshot error",
      toReasonMessage(gfalExResult.reason),
    );
  }
  if (loginResult.status === "rejected") {
    console.error(
      "initPlugin userLogin error",
      toReasonMessage(loginResult.reason),
    );
  }

  if (import.meta.client && loginResult.status === "fulfilled") {
    useAuthController().initClientLogin();
  }
});
